<template>
  <!--
      	作者：zhuchangtao
      	时间：2021-07-01
      	描述：活动列表 - 打卡规则
      -->
  <div >
    <div class="common-form">抽奖规则设置</div>



    <div >
      <el-form-item label="每次抽奖消耗积分">
        <div class="max-w460 d-s-c">
          <el-table :data="form.gradeList" border size="mini" style="width: 100%">
            <el-table-column prop="name" label="会员等级">
            </el-table-column>
            <el-table-column prop="name"  label="消耗积分">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input v-model="scope.row.points" type="text" placeholder="请输入积分"></el-input>

                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>


    </div>
  </div>
</template>

<script>
export default {
  components: {
    /*选择商品组件*/
  },
  data(){
    return {
      /*打卡奖励类型*/
      clockType: false,
      index:null,

    };
  },
  props: ['form'],
  methods: {


  }
};
</script>

<style>
 .ad-picture {
    width: 30px;
    height: 30px;
    border-radius: 16px;
    font-size: 40px;
    border: 1px dashed #cccccc;
    color: $blue;
    cursor: pointer;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/sweepstakes/sweepstakes/part/Clock.vue